module.exports = __webpack_public_path__ + "assets/a11yMenuIcon-d169bb.svg";